/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 21.04.2016
 *
 */
'use strict';

//Includes
import { amdDefine, AppContext } from 'plugin/liferay-widgets-react-web';
import { BaseRemoteVectorLayerController } from 'plugin/base-portlet';

import './css/icons.scss';

import FliwasOrganizationDefaultPositionPlugin from './plugins/FliwasOrganizationDefaultPositionPlugin';

// WebApi
import { default as FliwasOrganizationWebApi } from './webapi/FliwasOrganizationWebApi';
// Actions
import FliwasOrganizationActions from './actions/FliwasOrganizationActions';
//Components
import { default as FliwasOrganizationDetails } from './components/FliwasOrganizationDetails';
import { STORE_KEY_CURRENT_ORGANIZATION } from './constants/Constants';
import FliwasOrganizationFeatureRenderer from './map/FliwasOrganizationFeatureRenderer';
import {
    FliwasOrganizationsAllLayer,
    FliwasOrganizationsCommuneLayer,
    FliwasOrganizationsDistrictLayer,
    FliwasOrganizationsRpLayer
} from './constants/MapLayer';

export * from './constants/Constants';

export { FliwasOrganizationDefaultPositionPlugin };

const MapPlugins = {
    FliwasOrganizationDefaultPositionPlugin
};

export const map_plugins_FliwasOrganizationDefaultPositionPlugin = FliwasOrganizationDefaultPositionPlugin;

Object.keys(MapPlugins).map(k => {
    const name = 'map_plugins_' + k;
    amdDefine(name, [], () => {
        console.log('Defined Map Plugin from Module fliwas-structure ' + name);
    });
    return name;
});


export { FliwasOrganizationWebApi };


export { FliwasOrganizationActions };


export { FliwasOrganizationDetails };
export { default as FliwasOrganizationMapLinkListItem } from './map/FliwasOrganizationMapLinkListItem';

// ControllerViews
export { default as FliwasOrganizationMasterDetailWidget } from './widgets/FliwasOrganizationMasterDetailWidget';

export * from './stores/StoreFactory';

const GlobalFliwasOrganizationsAllLayer = {
    ...FliwasOrganizationsAllLayer,
    id: 'fliwas_organizations',
    uuid: 'fliwas_organizations',
    controller: BaseRemoteVectorLayerController
};
const GlobalFliwasOrganizationsRpLayer = {
    ...FliwasOrganizationsRpLayer,
    id: 'fliwas_organizations_rp',
    uuid: 'fliwas_organizations_rp',
    controller: BaseRemoteVectorLayerController
};
const GlobalFliwasOrganizationsDistrictLayer = {
    ...FliwasOrganizationsDistrictLayer,
    id: 'fliwas_organizations_district',
    uuid: 'fliwas_organizations_district',
    controller: BaseRemoteVectorLayerController
};
const GlobalFliwasOrganizationsCommuneLayer = {
    ...FliwasOrganizationsCommuneLayer,
    id: 'fliwas_organizations_commune',
    uuid: 'fliwas_organizations_commune',
    controller: BaseRemoteVectorLayerController
};


/*const GlobalFliwasOrganizationsAllLayer = {
    ...FliwasOrganizationsAllLayer,
    id: 'fliwas_organizations',
    uuid: 'fliwas_organizations',
    controller: BaseRemoteDataLayerController
};
const GlobalFliwasOrganizationsRpLayer = {
    ...FliwasOrganizationsRpLayer,
    id: 'fliwas_organizations_rp',
    uuid: 'fliwas_organizations_rp',
    controller: BaseRemoteDataLayerController
};
const GlobalFliwasOrganizationsDistrictLayer = {
    ...FliwasOrganizationsDistrictLayer,
    id: 'fliwas_organizations_district',
    uuid: 'fliwas_organizations_district',
    controller: BaseRemoteDataLayerController
};
const GlobalFliwasOrganizationsCommuneLayer = {
    ...FliwasOrganizationsCommuneLayer,
    id: 'fliwas_organizations_commune',
    uuid: 'fliwas_organizations_commune',
    controller: BaseRemoteDataLayerController
};*/

export { GlobalFliwasOrganizationsAllLayer };
export { GlobalFliwasOrganizationsRpLayer };
export { GlobalFliwasOrganizationsDistrictLayer };
export { GlobalFliwasOrganizationsCommuneLayer };

//Widgets
export { default as FliwasOrganizationConfigForm } from './widgets/FliwasOrganizationConfigForm';
export { default as FliwasMultiOrganizationConfigForm } from './widgets/FliwasMultiOrganizationConfigForm';


AppContext.registerBundle({
    webApis: {
        FliwasOrganizationWebApi
    }
});

FliwasOrganizationActions.itemByGroupId(STORE_KEY_CURRENT_ORGANIZATION, { id: AppContext.getScopeGroupId() }); //early load CurrentOrganization*/

export const Group = undefined;
export const FeatureRenderer_Group = FliwasOrganizationFeatureRenderer;






// WEBPACK FOOTER //
// ./js/fliwas-structure-portlet.js